import { useState } from "react";
import { css } from "@emotion/react";

import Modal from "react-modal";
import YouTube from "react-youtube";

import { useGetMediaSize } from "../../hooks";

export type MediaModalProps = {
  type: "image" | "youtube";
  id: string | undefined;
  onClose: () => void;
  getMediaArgs: Parameters<typeof useGetMediaSize>[0];
};

const modalStyleProp: Modal.Styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(208, 1, 18, 0.8)",
    transition: "opacity 200ms ease-in-out",
  },
};

const MediaModal: React.FC<MediaModalProps> = (props) => {
  const { type, id, onClose, getMediaArgs } = props;

  const [isReady, setIsReady] = useState(false);

  const { width, height } = useGetMediaSize(getMediaArgs);

  if (!id) return null;
  return (
    <Modal
      isOpen={!!id}
      style={modalStyleProp}
      css={modalStyle}
      overlayClassName="modalOverlay"
    >
      {type === "image" && width > 0 && (
        <img
          src={id}
          onLoad={() => setIsReady(true)}
          css={[mediaStyle(isReady), imgStyle(width)]}
        />
      )}
      {type === "youtube" && width > 0 && (
        <YouTube
          videoId={id}
          opts={{ width, height }}
          onReady={() => setIsReady(true)}
          css={mediaStyle(isReady)}
        />
      )}
      {isReady && (
        <img
          onClick={onClose}
          src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/modal-close.png"}
          alt="close"
          css={closeButtonStyle}
        />
      )}
    </Modal>
  );
};

const spSize = 768;

const modalStyle = css`
  z-index: 10;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  &:focus-visible {
    outline: none;
  }
`;

const mediaStyle = (isReady: boolean) => css`
  display: ${isReady ? "block" : "none"};
`;

const imgStyle = (width: number) => css`
  max-width: ${width}px;
  max-height: 80vh;
`;

const closeButtonStyle = css`
  position: absolute;
  top: -25px;
  right: -25px;
  width: 30px;
  height: 30px;
  width: 50px;
  height: 50px;

  @media (max-width: ${spSize}px) {
    top: -15px;
    right: -15px;
    width: 30px;
    height: 30px;
  }

  &:hover {
    cursor: pointer;
  }
`;

export default MediaModal;
